// Re-export background themes from @repo/tokens (single source of truth)
export {
  BACKGROUND_THEMES,
  BACKGROUND_THEME_NAMES,
  DEFAULT_BACKGROUND_THEME,
} from '@repo/tokens';

export type { BackgroundThemeName, BackgroundThemePalette, BackgroundTheme } from '@repo/tokens';
